import React, { memo } from 'react';
import { clsb } from 'js/utils/classNames.util';
import { I18n } from 'js/components/common/I18n';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

import * as Types from './types';

import '../../FormFields.scss';
import style from './FieldBottomMessage.scss';

export const FieldBottomMessageBare: React.FC<Types.IFieldBottomMessageProps> = ({ meta, hint, classNames }) => {
    const hintClassName = clsb([style, classNames], ['hint']);
    const hintContent = typeof hint === 'string'
        ? <I18n tKey={hint} defaultValue={hint} className={hintClassName} />
        : <span className={hintClassName}>{hint}</span>;

    return (
        <>
            {hint && hintContent}

            {meta?.error && meta?.touched && !meta?.active && !meta?.validating && (
                <ErrorMessage error={meta?.error || meta?.submitError} classNames={{ error: style.error, ...classNames }} />
            )}
        </>
    );
};

export const FieldBottomMessage = memo(FieldBottomMessageBare);
